<template lang="">
	<div id="imo5-main">
		<div class="row mb-4">
			<div class="col-sm-12">
				<div class="d-flex align-items-center mb-2">
					<h4 class="m-0 me-4"><span v-if="id > 0">EDIT</span><span v-else>ADD</span> IMO 5 CONDITION Record</h4>
					<a id="add_imo5_btn" class="btn btn-outline-dark btn-sm" :href="docRoot+'/imo5condition'">Back to list</a>
				</div>
			</div>
		</div>
		<div class="row mb-4 align-items-center">
			<div class="col-md-2 text-md-end px-1">
				<label for="add_imo5_container_no" class="form-label text-uppercase fw-bold m-0 me-3">Container No <span class="mandatory">*</span></label
				><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
			</div>
			<div class="col-md-3">
				<div class="input-group">
					<MaskInput v-model="imo5conditionForAdd.container_no" mask="AAAA-######-#" class="form-control" :readonly="tankNoVerified" placeholder="Enter Tank No" textmode="uppercase"/>
					<span class="input-group-text" :class="tankNoVerified ? 'bg-success' : 'bg-danger'">
						<i class="ph ph-check text-white" v-if="tankNoVerified"></i>
						<i class="ph ph-x text-white" v-if="!tankNoVerified"></i>
					</span>
				</div>
				<template v-for="error of v$.imo5conditionForAdd.container_no.$errors" :key="error.$uid">
					<div class="mandatory mb-1">{{ error.$message }}</div>
				</template>
			</div>
			<div class="col-md-4 col-12 mt-2 mt-md-0" v-if="!tankNoVerified">
				<button type="button" class="btn btn-dark btn-sm" @click="verifyTankNumber()">VERIFY TANK NUMBER</button>
			</div>
			<div class="col-md-6 py-2" v-if="imo5conditionForAdd.id == 0 && tankNoVerified">
				<label for="">Tank last used: <span v-if="lastThree && lastThree.length > 0">On {{  lastThree.join(", ") }}</span><span v-else>Never</span></label>
			</div>
		</div>
		<!--  -->
		<template v-if="tankNoVerified">
			<div class="row mb-4 g-2">
				<div class="col-md-2 col-6 text-md-end px-1">
					<label for="add_imo5condition_refno" class="form-label text-uppercase fw-bold pt-2 me-3">Ref No</label>
				</div>
				<div class="col-md-3 col-6">
					<input type="text" class="form-control" v-model="imo5conditionForAdd.refno" id="add_imo5condition_refno" placeholder="AUTOGENERATED" readonly />
				</div>
				<div class="col-md-2 col-6 text-md-end px-1">
					<label for="add_imo5condition_tank_type_id" class="form-label text-uppercase fw-bold pt-2 me-3">Tank Type</label>
				</div>
				<div class="col-md-3 col-6">
					<select class="form-select" v-model="imo5conditionForAdd.tank_type_id" id="add_tank_type_id">
						<optgroup v-if="allTankTypeIdList" label="Choose Tank Type">
							<template v-for="tankTypeId in allTankTypeIdList" :key="tankTypeId.id">
								<option :value="tankTypeId.id">{{ tankTypeId.type }}</option>
							</template>
						</optgroup>
					</select>
				</div>
			</div>
			<div class="row mb-4 g-2">
				<div class="col-md-2 col-6 text-md-end px-1">
					<label for="add_imo5condition_tcode_id" class="form-label text-uppercase fw-bold pt-2 me-3">TCode</label>
				</div>
				<div class="col-md-3 col-6">
					<div>
						<select class="form-select" v-model="imo5conditionForAdd.tcode_id" id="add_tcode_id">
							<optgroup v-if="allTcodeIdList" label="Choose TCode">
								<template v-for="tcodeId in allTcodeIdList" :key="tcodeId.id">
									<option :value="tcodeId.id">{{ tcodeId.name }}</option>
								</template>
							</optgroup>
						</select>
					</div>
				</div>
				<div class="col-md-2 col-12 text-md-end px-1">
					<label for="add_imo5condition_imo_status" class="form-label text-uppercase fw-bold pt-2 me-3">Imo Status</label>
				</div>
				<div class="col-md-3 col-12">
					<div class="input-group">
						<select class="form-select" v-model="imo5conditionForAdd.imo_status" id="add_imo_status">
							<optgroup v-if="allImoStatusList" label="Choose Imo Status">
								<template v-for="imoStatus in allImoStatusList" :key="imoStatus.id">
									<option :value="imoStatus.id">{{ imoStatus.title }}</option>
								</template>
							</optgroup>
						</select>
						<select class="form-select" v-model="imo5conditionForAdd.sealed" id="add_sealed">
							<optgroup v-if="allSealedList" label="Choose Sealed">
								<template v-for="sealed in allSealedList" :key="sealed.id">
									<option :value="sealed.id">{{ sealed.title }}</option>
								</template>
							</optgroup>
						</select>
					</div>
				</div>
			</div>
			<div class="row mb-4  g-2">
				<div class="col-md-2 col-6 text-md-end px-1">
					<label for="add_imo5condition_client" class="form-label text-uppercase fw-bold pt-2 me-3">At the Request of</label
					><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
				</div>
				<div class="col-md-3 col-6">
					<div>
						<input type="text" class="form-control" v-model="imo5conditionForAdd.client" id="add_imo5condition_client" placeholder="Enter Client" />
					</div>
				</div>
				<div class="col-md-2 col-6 text-md-end px-1">
					<label for="add_imo5condition_cleaning_location_id" class="form-label text-uppercase fw-bold pt-2 me-3">Depot</label>
				</div>
				<div class="col-md-3 col-6">
					<div>
						<multiselect v-model="imo5conditionForAdd.cleaning_location_id" :options="allCleaningLocationIdList" :custom-label="displayLabelSetting" placeholder="Select one" selectLabel="" deselectLabel=""></multiselect>
					</div>
				</div>
			</div>
			<div class="row mb-4  g-2">
				<div class="col-md-2 col-6 text-md-end px-1">
					<label for="add_imo5condition_capacity" class="form-label text-uppercase fw-bold pt-2 me-3">Tank Capacity</label
					><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
				</div>
				<div class="col-md-3 col-6">
					<div>
						<input type="text" class="form-control" v-model="imo5conditionForAdd.capacity" id="add_imo5condition_capacity" placeholder="Enter Capacity" />
					</div>
				</div>
				<div class="col-md-2 col-6 text-md-end px-1">
					<label for="add_imo5condition_survey_date" class="form-label text-uppercase fw-bold pt-2 me-3">Survey Date</label>
				</div>
				<div class="col-md-3 col-6">
					<div>
						<input type="date" class="form-control" v-model="imo5conditionForAdd.survey_date" id="add_imo5condition_survey_date" placeholder="Enter Survey Date" />
					</div>
				</div>
			</div>
			<div class="row mb-4 g-2">
				<div class="col-md-2 col-6 text-md-end px-1">
					<label for="add_imo5condition_mfgt_date" class="form-label text-uppercase fw-bold pt-2 me-3">Mfgt Date</label>
				</div>
				<div class="col-md-3 col-6">
					<div>
						<!-- <MonthYearPicker  v-model="imo5conditionForAdd.mfgt_date" :min="new Date(1990, 1, 1)" :max="new Date()" returnmode="String" class="form-select"/> -->
						<input type="text" class="form-control" v-model="imo5conditionForAdd.mfgt_date" id="add_imo5condition_mfgt_date" placeholder="Enter Mfgt Date" />
					</div>
				</div>
				<div class="col-md-2 col-6 text-md-end px-1">
					<label for="add_imo5condition_customer_id" class="form-label text-uppercase fw-bold pt-2 me-3">Customer <span class="mandatory">*</span></label>
				</div>
				<div class="col-md-3 col-6">
					<div>
						<multiselect v-model="imo5conditionForAdd.customer_id" :options="allCustomerIdList" :custom-label="displayLabelSetting" placeholder="Select one" selectLabel="" deselectLabel=""></multiselect>
					</div>
					<template v-for="error of v$.imo5conditionForAdd.customer_id.$errors" :key="error.$uid">
						<div class="mandatory mb-1">{{ error.$message }}</div>
					</template>
				</div>
			</div>
			<div class="row mb-4 g-2">
				<div class="col-md-2 col-6 text-md-end px-1">
					<label for="add_imo5condition_gross_wt" class="form-label text-uppercase fw-bold pt-2 me-3">Max Gross Wt</label>
				</div>
				<div class="col-md-3 col-6">
					<div>
						<input type="number" v-empty-zero class="form-control" v-model="imo5conditionForAdd.gross_wt" id="add_imo5condition_gross_wt" placeholder="Enter Gross Wt" />
					</div>
				</div>
				<div class="col-md-2 col-6 text-md-end px-1">
					<label for="add_imo5condition_tare_wt" class="form-label text-uppercase fw-bold pt-2 me-3">Tare Wt</label>
				</div>
				<div class="col-md-3 col-6">
					<div>
						<input type="number" v-empty-zero class="form-control" v-model="imo5conditionForAdd.tare_wt" id="add_imo5condition_tare_wt" placeholder="Enter Tare Wt" />
					</div>
				</div>
			</div>
			<div class="row mb-4 g-2">
				<div class="col-md-2 col-6 text-md-end px-1">
					<label for="add_imo5condition_csc" class="form-label text-uppercase fw-bold pt-2 me-3">Csc</label
					><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
				</div>
				<div class="col-md-3 col-6">
					<div>
						<input type="text" class="form-control" v-model="imo5conditionForAdd.csc" id="add_imo5condition_csc" placeholder="Enter Csc" />
					</div>
				</div>
				<div class="col-md-2 col-6 text-md-end px-1">
					<label for="add_imo5condition_scover" class="form-label text-uppercase fw-bold pt-2 me-3">Sunshield Cover</label>
				</div>
				<div class="col-md-3 col-6">
					<div>
						<select class="form-select" v-model="imo5conditionForAdd.scover" id="add_scover">
							<optgroup v-if="arrYesNo" label="Choose Scover">
								<template v-for="scover in arrYesNo" :key="scover.id">
									<option :value="scover.id">{{ scover.title }}</option>
								</template>
							</optgroup>
						</select>
					</div>
				</div>
			</div>
			<div class="row mb-4 g-2">
				<div class="col-md-2 col-6 text-md-end px-1">
					<label for="add_imo5condition_inspection_location_id" class="form-label text-uppercase fw-bold pt-2 me-3">Inspection Location</label>
				</div>
				<div class="col-md-3 col-6">
					<div>
						<multiselect v-model="imo5conditionForAdd.inspection_location_id" :options="allInspectionLocationIdList" :custom-label="displayLabelSetting" placeholder="Select one" selectLabel="" deselectLabel=""></multiselect>
					</div>
				</div>
				<div class="col-md-2 text-md-end px-1">
					<label for="add_imo5condition_bvboxyn" class="form-label text-uppercase fw-bold pt-2 me-3">Bottom Valve Box</label>
				</div>
				<div class="col-md-3">
					<div class="input-group">
						<select class="form-select" v-model="imo5conditionForAdd.bvboxyn" id="add_bvboxyn">
							<optgroup v-if="arrYesNo" label="Choose">
								<template v-for="bvboxyn in arrYesNo" :key="bvboxyn.id">
									<option :value="bvboxyn.id">{{ bvboxyn.title }}</option>
								</template>
							</optgroup>
						</select>
						<select class="form-select" v-model="imo5conditionForAdd.bvboxsu" id="add_bvboxsu">
							<optgroup v-if="allBvboxsuList" label="Choose">
								<template v-for="bvboxsu in allBvboxsuList" :key="bvboxsu.id">
									<option :value="bvboxsu.id">{{ bvboxsu.title }}</option>
								</template>
							</optgroup>
						</select>
					</div>
				</div>
			</div>
			<div class="row mb-4 g-2">
				<div class="col-md-2 col-6 text-md-end px-1">
					<label for="add_imo5condition_next_date" class="form-label text-uppercase fw-bold pt-2 me-3">Next Date</label>
				</div>
				<div class="col-md-3 col-6">
					<div>
						<input type="date" class="form-control" v-model="imo5conditionForAdd.next_date" id="add_imo5condition_next_date" placeholder="Enter Next Date" />
					</div>
				</div>
			</div>
			<div class="row mb-4">
				<div class="col-md-2 col-6 text-md-end px-1">
					<label for="add_imo5condition_comments" class="form-label text-uppercase fw-bold pt-2 me-3">Comments</label
					><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
				</div>
				<div class="col-md-3">
					<div>
						<textarea class="form-control" v-model="imo5conditionForAdd.comments" id="add_imo5condition_comments" placeholder="Enter Comments"></textarea>
					</div>
				</div>
			</div>
			<!-- /*/* -->
			<div class="row mb-2 border-secondary border-bottom">
				<div class="col-4 fw-bold text-center p-2 text-primary d-none d-md-block">COMPONENT CHECK LIST</div>
				<div class="col-md-2 col-3 fw-bold text-center p-2 text-primary">FITTED</div>
				<div class="col-md-2 col-3 fw-bold text-center p-2 text-primary">CONDITION</div>
				<div class="col-md-4 col-6 fw-bold text-center p-2 text-primary">REMARKS</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_markings_fitted_yes" class="form-label text-uppercase fw-bold pt-2 me-3">MARKINGS AND PLATES</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.markings_fitted_yes" id="add_markings_fitted_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="markingsFittedYes in arrYesNoNA" :key="markingsFittedYes.id">
								<option :value="markingsFittedYes.id">{{ markingsFittedYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.markings_condition_good" id="add_markings_condition_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="markingsConditionGood in arrYesNoNA" :key="markingsConditionGood.id">
								<option :value="markingsConditionGood.id">{{ markingsConditionGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.marking_plates" id="add_imo5condition_marking_plates" placeholder="Enter Marking Plates"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_data_fitted_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Data Plate</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.data_fitted_yes" id="add_data_fitted_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="dataFittedYes in arrYesNoNA" :key="dataFittedYes.id">
								<option :value="dataFittedYes.id">{{ dataFittedYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.data_condition_good" id="add_data_condition_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="dataConditionGood in arrYesNoNA" :key="dataConditionGood.id">
								<option :value="dataConditionGood.id">{{ dataConditionGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.data_plate" id="add_imo5condition_data_plate" placeholder="Enter Data Plate"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_owners_plate_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Owners Plate</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.owners_plate_yes" id="add_owners_plate_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="ownersPlateYes in arrYesNoNA" :key="ownersPlateYes.id">
								<option :value="ownersPlateYes.id">{{ ownersPlateYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.owners_plate_good" id="add_owners_plate_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="ownersPlateGood in arrYesNoNA" :key="ownersPlateGood.id">
								<option :value="ownersPlateGood.id">{{ ownersPlateGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4  col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.owners_plate" id="add_imo5condition_owners_plate" placeholder="Enter Owners Plate"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_manufactures_plate_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Manufactures Plate</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.manufactures_plate_yes" id="add_manufactures_plate_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="manufacturesPlateYes in arrYesNoNA" :key="manufacturesPlateYes.id">
								<option :value="manufacturesPlateYes.id">{{ manufacturesPlateYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.manufactures_plate_good" id="add_manufactures_plate_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="manufacturesPlateGood in arrYesNoNA" :key="manufacturesPlateGood.id">
								<option :value="manufacturesPlateGood.id">{{ manufacturesPlateGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.manufactures_plates" id="add_imo5condition_manufactures_plates" placeholder="Enter Manufactures Plates"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_csc_plate_yes" class="form-label text-uppercase fw-bold pt-2 me-3">CSC Plate</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.csc_plate_yes" id="add_csc_plate_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="cscPlateYes in arrYesNoNA" :key="cscPlateYes.id">
								<option :value="cscPlateYes.id">{{ cscPlateYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.csc_plate_good" id="add_csc_plate_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="cscPlateGood in arrYesNoNA" :key="cscPlateGood.id">
								<option :value="cscPlateGood.id">{{ cscPlateGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.csc_plate" id="add_imo5condition_csc_plate" placeholder="Enter Csc Plate"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_customs_plate_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Customs approval plate</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.customs_plate_yes" id="add_customs_plate_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="customsPlateYes in arrYesNoNA" :key="customsPlateYes.id">
								<option :value="customsPlateYes.id">{{ customsPlateYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.customs_plate_good" id="add_customs_plate_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="customsPlateGood in arrYesNoNA" :key="customsPlateGood.id">
								<option :value="customsPlateGood.id">{{ customsPlateGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.customs_plate" id="add_imo5condition_customs_plate" placeholder="Enter Customs Plate"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_prefix_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Prefix/Number</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.prefix_yes" id="add_prefix_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="prefixYes in arrYesNoNA" :key="prefixYes.id">
								<option :value="prefixYes.id">{{ prefixYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.prefix_good" id="add_prefix_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="prefixGood in arrYesNoNA" :key="prefixGood.id">
								<option :value="prefixGood.id">{{ prefixGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.prefix" id="add_imo5condition_prefix" placeholder="Enter Prefix"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_imo_yes" class="form-label text-uppercase fw-bold pt-2 me-3">IMO/Number</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.imo_yes" id="add_imo_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="imoYes in arrYesNoNA" :key="imoYes.id">
								<option :value="imoYes.id">{{ imoYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.imo_good" id="add_imo_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="imoGood in arrYesNoNA" :key="imoGood.id">
								<option :value="imoGood.id">{{ imoGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.imo" id="add_imo5condition_imo" placeholder="Enter Imo"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_country_code_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Country Code</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.country_code_yes" id="add_country_code_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="countryCodeYes in arrYesNoNA" :key="countryCodeYes.id">
								<option :value="countryCodeYes.id">{{ countryCodeYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.country_code_good" id="add_country_code_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="countryCodeGood in arrYesNoNA" :key="countryCodeGood.id">
								<option :value="countryCodeGood.id">{{ countryCodeGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.country_code" id="add_imo5condition_country_code" placeholder="Enter Country Code"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_front_ladder_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Front Ladder</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.front_ladder_yes" id="add_front_ladder_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="frontLadderYes in arrYesNoNA" :key="frontLadderYes.id">
								<option :value="frontLadderYes.id">{{ frontLadderYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.front_ladder_good" id="add_front_ladder_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="frontLadderGood in arrYesNoNA" :key="frontLadderGood.id">
								<option :value="frontLadderGood.id">{{ frontLadderGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.front_ladder" id="add_imo5condition_front_ladder" placeholder="Enter Front Ladder"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_rear_ladder_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Rear Ladder</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.rear_ladder_yes" id="add_rear_ladder_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="rearLadderYes in arrYesNoNA" :key="rearLadderYes.id">
								<option :value="rearLadderYes.id">{{ rearLadderYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.rear_ladder_good" id="add_rear_ladder_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="rearLadderGood in arrYesNoNA" :key="rearLadderGood.id">
								<option :value="rearLadderGood.id">{{ rearLadderGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.rear_ladder" id="add_imo5condition_rear_ladder" placeholder="Enter Rear Ladder"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_document_box_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Document Box/Cap/Gask/Chain</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.document_box_yes" id="add_document_box_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="documentBoxYes in arrYesNoNA" :key="documentBoxYes.id">
								<option :value="documentBoxYes.id">{{ documentBoxYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.document_box_good" id="add_document_box_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="documentBoxGood in arrYesNoNA" :key="documentBoxGood.id">
								<option :value="documentBoxGood.id">{{ documentBoxGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.document_box" id="add_imo5condition_document_box" placeholder="Enter Document Box"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_outlet_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Outlet/Blank/Gask/Chain</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.outlet_yes" id="add_outlet_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="outletYes in arrYesNoNA" :key="outletYes.id">
								<option :value="outletYes.id">{{ outletYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.outlet_good" id="add_outlet_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="outletGood in arrYesNoNA" :key="outletGood.id">
								<option :value="outletGood.id">{{ outletGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.outlet" id="add_imo5condition_outlet" placeholder="Enter Outlet"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_bottom_outlet_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Bottom outlet valve/gaskets</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.bottom_outlet_yes" id="add_bottom_outlet_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="bottomOutletYes in arrYesNoNA" :key="bottomOutletYes.id">
								<option :value="bottomOutletYes.id">{{ bottomOutletYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.bottom_outlet_good" id="add_bottom_outlet_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="bottomOutletGood in arrYesNoNA" :key="bottomOutletGood.id">
								<option :value="bottomOutletGood.id">{{ bottomOutletGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.bottom_outlet" id="add_imo5condition_bottom_outlet" placeholder="Enter Bottom Outlet"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_foot_valve_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Footvalve</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.foot_valve_yes" id="add_foot_valve_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="footValveYes in arrYesNoNA" :key="footValveYes.id">
								<option :value="footValveYes.id">{{ footValveYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.foot_valve_good" id="add_foot_valve_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="footValveGood in arrYesNoNA" :key="footValveGood.id">
								<option :value="footValveGood.id">{{ footValveGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.foot_valve" id="add_imo5condition_foot_valve" placeholder="Enter Foot Valve"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_remote_footvalve_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Remote Footvalve control</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.remote_footvalve_yes" id="add_remote_footvalve_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="remoteFootvalveYes in arrYesNoNA" :key="remoteFootvalveYes.id">
								<option :value="remoteFootvalveYes.id">{{ remoteFootvalveYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.remote_footvalve_good" id="add_remote_footvalve_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="remoteFootvalveGood in arrYesNoNA" :key="remoteFootvalveGood.id">
								<option :value="remoteFootvalveGood.id">{{ remoteFootvalveGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.remote_footvalve" id="add_imo5condition_remote_footvalve" placeholder="Enter Remote Footvalve"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_steam_tubes_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Steam Tubes/Cap/Gask/Chain</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.steam_tubes_yes" id="add_steam_tubes_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="steamTubesYes in arrYesNoNA" :key="steamTubesYes.id">
								<option :value="steamTubesYes.id">{{ steamTubesYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.steam_tubes_good" id="add_steam_tubes_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="steamTubesGood in arrYesNoNA" :key="steamTubesGood.id">
								<option :value="steamTubesGood.id">{{ steamTubesGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.steam_tubes" id="add_imo5condition_steam_tubes" placeholder="Enter Steam Tubes"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_condensate_drains_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Condensate drain</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.condensate_drains_yes" id="add_condensate_drains_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="condensateDrainsYes in arrYesNoNA" :key="condensateDrainsYes.id">
								<option :value="condensateDrainsYes.id">{{ condensateDrainsYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.condensate_drains_good" id="add_condensate_drains_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="condensateDrainsGood in arrYesNoNA" :key="condensateDrainsGood.id">
								<option :value="condensateDrainsGood.id">{{ condensateDrainsGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.condensate_drains" id="add_imo5condition_condensate_drains" placeholder="Enter Condensate Drains"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_thermometer_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Thermometer</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.thermometer_yes" id="add_thermometer_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="thermometerYes in arrYesNoNA" :key="thermometerYes.id">
								<option :value="thermometerYes.id">{{ thermometerYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.thermometer_good" id="add_thermometer_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="thermometerGood in arrYesNoNA" :key="thermometerGood.id">
								<option :value="thermometerGood.id">{{ thermometerGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.thermometer" id="add_imo5condition_thermometer" placeholder="Enter Thermometer"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_walkway_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Walkway</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.walkway_yes" id="add_walkway_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="walkwayYes in arrYesNoNA" :key="walkwayYes.id">
								<option :value="walkwayYes.id">{{ walkwayYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.walkway_good" id="add_walkway_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="walkwayGood in arrYesNoNA" :key="walkwayGood.id">
								<option :value="walkwayGood.id">{{ walkwayGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.walkway" id="add_imo5condition_walkway" placeholder="Enter Walkway"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_manlid_protection_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Manlid Protection Cover</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.manlid_protection_yes" id="add_manlid_protection_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="manlidProtectionYes in arrYesNoNA" :key="manlidProtectionYes.id">
								<option :value="manlidProtectionYes.id">{{ manlidProtectionYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.manlid_protection_good" id="add_manlid_protection_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="manlidProtectionGood in arrYesNoNA" :key="manlidProtectionGood.id">
								<option :value="manlidProtectionGood.id">{{ manlidProtectionGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.manlid_protection" id="add_imo5condition_manlid_protection" placeholder="Enter Manlid Protection"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_spillbox_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Spillbox</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.spillbox_yes" id="add_spillbox_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="spillboxYes in arrYesNoNA" :key="spillboxYes.id">
								<option :value="spillboxYes.id">{{ spillboxYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.spillbox_good" id="add_spillbox_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="spillboxGood in arrYesNoNA" :key="spillboxGood.id">
								<option :value="spillboxGood.id">{{ spillboxGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.spillbox" id="add_imo5condition_spillbox" placeholder="Enter Spillbox"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_manlid_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Manlid</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.manlid_yes" id="add_manlid_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="manlidYes in arrYesNoNA" :key="manlidYes.id">
								<option :value="manlidYes.id">{{ manlidYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.manlid_good" id="add_manlid_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="manlidGood in arrYesNoNA" :key="manlidGood.id">
								<option :value="manlidGood.id">{{ manlidGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.manlid" id="add_imo5condition_manlid" placeholder="Enter Manlid"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_manlid_bolts_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Manlid Bolts</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.manlid_bolts_yes" id="add_manlid_bolts_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="manlidBoltsYes in arrYesNoNA" :key="manlidBoltsYes.id">
								<option :value="manlidBoltsYes.id">{{ manlidBoltsYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.manlid_bolts_good" id="add_manlid_bolts_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="manlidBoltsGood in arrYesNoNA" :key="manlidBoltsGood.id">
								<option :value="manlidBoltsGood.id">{{ manlidBoltsGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.manlid_bolts" id="add_imo5condition_manlid_bolts" placeholder="Enter Manlid Bolts"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_dipstick_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Dipstick</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.dipstick_yes" id="add_dipstick_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="dipstickYes in arrYesNoNA" :key="dipstickYes.id">
								<option :value="dipstickYes.id">{{ dipstickYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.dipstick_good" id="add_dipstick_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="dipstickGood in arrYesNoNA" :key="dipstickGood.id">
								<option :value="dipstickGood.id">{{ dipstickGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.dipstick" id="add_imo5condition_dipstick" placeholder="Enter Dipstick"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_safety_cover_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Safety Dev.Prot.Cover</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.safety_cover_yes" id="add_safety_cover_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="safetyCoverYes in arrYesNoNA" :key="safetyCoverYes.id">
								<option :value="safetyCoverYes.id">{{ safetyCoverYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.safety_cover_good" id="add_safety_cover_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="safetyCoverGood in arrYesNoNA" :key="safetyCoverGood.id">
								<option :value="safetyCoverGood.id">{{ safetyCoverGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.safety_cover" id="add_imo5condition_safety_cover" placeholder="Enter Safety Cover"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_calibration_chart_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Calibration Chart</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.calibration_chart_yes" id="add_calibration_chart_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="calibrationChartYes in arrYesNoNA" :key="calibrationChartYes.id">
								<option :value="calibrationChartYes.id">{{ calibrationChartYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.calibration_chart_good" id="add_calibration_chart_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="calibrationChartGood in arrYesNoNA" :key="calibrationChartGood.id">
								<option :value="calibrationChartGood.id">{{ calibrationChartGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.calibration_chart" id="add_imo5condition_calibration_chart" placeholder="Enter Calibration Chart"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_relief_valves_yes" class="form-label text-uppercase fw-bold pt-2 me-3">P/V Relief Valves Yes</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.relief_valves_yes" id="add_relief_valves_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="reliefValvesYes in arrYesNoNA" :key="reliefValvesYes.id">
								<option :value="reliefValvesYes.id">{{ reliefValvesYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.relief_valves_good" id="add_relief_valves_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="reliefValvesGood in arrYesNoNA" :key="reliefValvesGood.id">
								<option :value="reliefValvesGood.id">{{ reliefValvesGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.relief_valves" id="add_imo5condition_relief_valves" placeholder="Enter Relief Valves"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_pressure_gauges_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Pressure Gauges</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.pressure_gauges_yes" id="add_pressure_gauges_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="pressureGaugesYes in arrYesNoNA" :key="pressureGaugesYes.id">
								<option :value="pressureGaugesYes.id">{{ pressureGaugesYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.pressure_gauges_good" id="add_pressure_gauges_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="pressureGaugesGood in arrYesNoNA" :key="pressureGaugesGood.id">
								<option :value="pressureGaugesGood.id">{{ pressureGaugesGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.pressure_gauges" id="add_imo5condition_pressure_gauges" placeholder="Enter Pressure Gauges"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_flame_traps_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Flame Traps on P/V Rel.Val.</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.flame_traps_yes" id="add_flame_traps_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="flameTrapsYes in arrYesNoNA" :key="flameTrapsYes.id">
								<option :value="flameTrapsYes.id">{{ flameTrapsYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.flame_traps_good" id="add_flame_traps_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="flameTrapsGood in arrYesNoNA" :key="flameTrapsGood.id">
								<option :value="flameTrapsGood.id">{{ flameTrapsGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.flame_traps" id="add_imo5condition_flame_traps" placeholder="Enter Flame Traps"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_air_line_cap_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Air Line Cap</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.air_line_cap_yes" id="add_air_line_cap_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="airLineCapYes in arrYesNoNA" :key="airLineCapYes.id">
								<option :value="airLineCapYes.id">{{ airLineCapYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.air_line_cap_good" id="add_air_line_cap_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="airLineCapGood in arrYesNoNA" :key="airLineCapGood.id">
								<option :value="airLineCapGood.id">{{ airLineCapGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.air_line_cap" id="add_imo5condition_air_line_cap" placeholder="Enter Air Line Cap"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_air_line_valve_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Air Line Valve</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.air_line_valve_yes" id="add_air_line_valve_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="airLineValveYes in arrYesNoNA" :key="airLineValveYes.id">
								<option :value="airLineValveYes.id">{{ airLineValveYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.air_line_valve_good" id="add_air_line_valve_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="airLineValveGood in arrYesNoNA" :key="airLineValveGood.id">
								<option :value="airLineValveGood.id">{{ airLineValveGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.air_line_valve" id="add_imo5condition_air_line_valve" placeholder="Enter Air Line Valve"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_top_disch_prot_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Top Disch Prot Cover </label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.top_disch_prot_yes" id="add_top_disch_prot_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="topDischProtYes in arrYesNoNA" :key="topDischProtYes.id">
								<option :value="topDischProtYes.id">{{ topDischProtYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.top_disch_prot_good" id="add_top_disch_prot_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="topDischProtGood in arrYesNoNA" :key="topDischProtGood.id">
								<option :value="topDischProtGood.id">{{ topDischProtGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.top_disch_prot" id="add_imo5condition_top_disch_prot" placeholder="Enter Top Disch Prot"></textarea>
				</div>
			</div>
			<div class="row mb-2 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_top_disch_valve_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Top Disch Valve</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.top_disch_valve_yes" id="add_top_disch_valve_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="topDischValveYes in arrYesNoNA" :key="topDischValveYes.id">
								<option :value="topDischValveYes.id">{{ topDischValveYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.top_disch_valve_good" id="add_top_disch_valve_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="topDischValveGood in arrYesNoNA" :key="topDischValveGood.id">
								<option :value="topDischValveGood.id">{{ topDischValveGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.top_disch_valve" id="add_imo5condition_top_disch_valve" placeholder="Enter Top Disch Valve"></textarea>
				</div>
			</div>
			<div class="row mb-4 pb-2 border-secondary border-bottom align-items-center g-2 g-md-3">
				<div class="col-md-4">
					<label for="add_imo5condition_top_condition_yes" class="form-label text-uppercase fw-bold pt-2 me-3">Top Disch. Blank</label>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.top_condition_yes" id="add_top_condition_yes">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="topConditionYes in arrYesNoNA" :key="topConditionYes.id">
								<option :value="topConditionYes.id">{{ topConditionYes.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-2 col-3">
					<select class="form-select" v-model="imo5conditionForAdd.top_condition_good" id="add_top_condition_good">
						<optgroup v-if="arrYesNoNA" label="Choose">
							<template v-for="topConditionGood in arrYesNoNA" :key="topConditionGood.id">
								<option :value="topConditionGood.id">{{ topConditionGood.title }}</option>
							</template>
						</optgroup>
					</select>
				</div>
				<div class="col-md-4 col-6">
					<textarea class="form-control" v-model="imo5conditionForAdd.top_condition" id="add_imo5condition_top_condition" placeholder="Enter Top Condition"></textarea>
				</div>
			</div>
		</template>
		<div class="row mb-5">
			<div class="col-md-3">
				<button type="button" class="btn btn-dark btn-sm w-100" v-if="tankNoVerified" @click="saveImo5Condition()">SAVE CHANGES</button>
			</div>
		</div>
	</div>
</template>
<script>
	import {useVuelidate} from "@vuelidate/core";
	import {required, minValue, alphaNum, numeric, email, requiredIf, minLength} from "@vuelidate/validators";
	import * as bootstrap from "bootstrap";
	function initialState() {
		return {
			id: 0,
			container_no: "",
			tank_type_id: null,
			tcode_id: null,
			client: "",
			capacity: "",
			mfgt_date: "",
			gross_wt: 0,
			csc: "",
			inspection_location_id: null,
			next_date: "",
			tare_wt: 0,
			imo_status: 0,
			sealed: 1,
			cleaning_location_id: null,
			survey_date: "",
			customer_id: null,
			refno: "",
			scover: 1,
			bvboxyn: 1,
			bvboxsu: 1,
			comments: "",
			markings_fitted_yes: 1,
			markings_condition_good: 1,
			marking_plates: "",
			data_fitted_yes: 1,
			data_condition_good: 1,
			data_plate: "",
			owners_plate_yes: 1,
			owners_plate_good: 1,
			owners_plate: "",
			manufactures_plate_yes: 1,
			manufactures_plate_good: 1,
			manufactures_plates: "",
			csc_plate_yes: 1,
			csc_plate_good: 1,
			csc_plate: "",
			customs_plate_yes: 1,
			customs_plate_good: 1,
			customs_plate: "",
			prefix_yes: 1,
			prefix_good: 1,
			prefix: "",
			imo_yes: 1,
			imo_good: 1,
			imo: "",
			country_code_yes: 1,
			country_code_good: 1,
			country_code: "",
			rear_ladder_yes: 1,
			rear_ladder_good: 1,
			rear_ladder: "",
			front_ladder_yes: 1,
			front_ladder_good: 1,
			front_ladder: "",
			document_box_yes: 1,
			document_box_good: 1,
			document_box: "",
			outlet_yes: 1,
			outlet_good: 1,
			outlet: "",
			bottom_outlet_yes: 1,
			bottom_outlet_good: 1,
			bottom_outlet: "",
			foot_valve_yes: 1,
			foot_valve_good: 1,
			foot_valve: "",
			remote_footvalve_yes: 1,
			remote_footvalve_good: 1,
			remote_footvalve: "",
			steam_tubes_yes: 1,
			steam_tubes_good: 1,
			steam_tubes: "",
			condensate_drains_yes: 1,
			condensate_drains_good: 1,
			condensate_drains: "",
			thermometer_yes: 1,
			thermometer_good: 1,
			thermometer: "",
			walkway_yes: 1,
			walkway_good: 1,
			walkway: "",
			manlid_protection_yes: 1,
			manlid_protection_good: 1,
			manlid_protection: "",
			spillbox_yes: 1,
			spillbox_good: 1,
			spillbox: "",
			manlid_yes: 1,
			manlid_good: 1,
			manlid: "",
			manlid_bolts_yes: 1,
			manlid_bolts_good: 1,
			manlid_bolts: "",
			dipstick_yes: 1,
			dipstick_good: 1,
			dipstick: "",
			safety_cover_yes: 1,
			safety_cover_good: 1,
			safety_cover: "",
			calibration_chart_yes: 1,
			calibration_chart_good: 1,
			calibration_chart: "",
			relief_valves_yes: 1,
			relief_valves_good: 1,
			relief_valves: "",
			pressure_gauges_yes: 1,
			pressure_gauges_good: 1,
			pressure_gauges: "",
			flame_traps_yes: 1,
			flame_traps_good: 1,
			flame_traps: "",
			air_line_cap_yes: 1,
			air_line_cap_good: 1,
			air_line_cap: "",
			air_line_valve_yes: 1,
			air_line_valve_good: 1,
			air_line_valve: "",
			top_disch_prot_yes: 1,
			top_disch_prot_good: 1,
			top_disch_prot: "",
			top_disch_valve_yes: 1,
			top_disch_valve_good: 1,
			top_disch_valve: "",
			top_condition_yes: 1,
			top_condition_good: 1,
			top_condition: "",

			action: ""
		};
	}
	function initialStateValidations() {
		return {
			container_no: {required, minLengthValue: minLength(1)},
			customer_id: {required}
		};
	}
	export default {
		name: "AddEditIMO5Condition",
		props: ["current_user_id", "all_permissions", "id","param1"],
		setup() {
			return {
				v$: useVuelidate()
			};
		},
		data() {
			return {
				currentUser: siteUserObject,
				tankNoVerified: false,
				lastThree: [],
				imo5conditionForAdd: initialState(),
				allTankTypeIdList: [],
				allTcodeIdList: [],
				allInspectionLocationIdList: [],
				allImoStatusList: [],
				allSealedList: [],
				allCleaningLocationIdList: [],
				allCustomerIdList: [],
				arrYesNo: [],
				arrYesNoNA: [],
				allBvboxsuList: []
			};
		},
		validations() {
			return {
				imo5conditionForAdd: initialStateValidations()
			};
		},
		methods: {
			cancelAddEdit(event) {
				this.imo5conditionForAdd = initialState();
				this.v$.$reset();
			},
			verifyTankNumber() {
				var that = this;
				this.showLoading("Verifying ...");
				axios.post(this.docRoot + "/imo5condition/verify-tank-number", {tankNo: this.imo5conditionForAdd.container_no}).then(async function (response) {
					that.closeSwal();
					console.log(response);
					var status = response.data.status;
					if (status == 1){
						that.tankNoVerified = true;
						if (response.data.hasOwnProperty("lastthree") && response.data.lastthree.length > 0) {
							let arrLastThree = response.data.lastthree;
							that.lastThree = arrLastThree.filter((item, index) => arrLastThree.indexOf(item) === index);
						}
					} else if (status == -1) {
						that.tankNoVerified = false;
						that.showErrors(response.data.message, "error", "bottom", 3000);
					}
				});
			},
			async saveImo5Condition(event) {
				var thisVar = this;
				const result = await this.v$.$validate();
				if (!result) {
					this.showToast("Form validation failed. Please check.", "error", "bottom", 2000);
					console.log(this.v$.$errors);
					return;
				}
				if ( this.imo5conditionForAdd.customer_id != 'null' && typeof this.imo5conditionForAdd.customer_id === 'object' && this.imo5conditionForAdd.customer_id.id) {
					this.imo5conditionForAdd.customer_id = this.imo5conditionForAdd.customer_id.id;
				}
				if ( this.imo5conditionForAdd.cleaning_location_id != 'null' && typeof this.imo5conditionForAdd.cleaning_location_id === 'object' && this.imo5conditionForAdd.cleaning_location_id.id) {
					this.imo5conditionForAdd.cleaning_location_id = this.imo5conditionForAdd.cleaning_location_id.id;
				}
				if ( this.imo5conditionForAdd.inspection_location_id != 'null' && typeof this.imo5conditionForAdd.inspection_location_id === 'object' && this.imo5conditionForAdd.inspection_location_id.id) {
					this.imo5conditionForAdd.inspection_location_id = this.imo5conditionForAdd.inspection_location_id.id;
				}
				if (!this.imo5conditionForAdd.action || this.imo5conditionForAdd.action == "") this.imo5conditionForAdd.action = "details";
				this.imo5conditionForAdd.created_by = this.current_user_id;
				this.showLoading("Saving ...");
				axios
					.post(this.docRoot+"/imo5condition/save", {imo5condition: this.imo5conditionForAdd})
					.then(async function (response) {
						thisVar.closeSwal();
						var status = response.data.status;
						if (status == 1) {
							// Ajax to submit
							thisVar.showToast("IMO 5 Condition saved successfully", "success", "bottom", 3000);
							if(thisVar.param1 === "mobileapp") {
								window.location = thisVar.docRoot + "/operation-successful/";
							}else{
								setTimeout(() => {
									window.location = thisVar.docRoot + "/imo5condition/";
									thisVar.showLoading("Loading ...");
								}, 1500);
							}
							// document.body.scrollTop = 0;
							// document.documentElement.scrollTop = 0;
						}
						else
							thisVar.showErrors("IMO 5 Condition could not be saved successfully", response.data.messages, "bottom", 3000);
					})
					.catch(function (error) {
						console.log(error);
						thisVar.closeSwal();
						thisVar.showToast("IMO 5 Condition could not be saved successfully", "error", "bottom", 3000);
					});
			},
			reloadEverything() {
				if (this.id !== undefined && !isNaN(this.id)) {
					this.mode = "edit";
					// This is Edit mode - fetch inquiry data
					var that = this;
					this.tankNoVerified = false;
					var URL = this.docRoot + "/api/imo5condition/get-record/" + this.id;
					this.showLoading("Loading ...");
					axios
						.post(URL, {})
						.then(function (response) {
							that.closeSwal();
							that.imo5conditionForAdd = Object.assign({}, response.data);
						})
						.catch(function (error) {
							console.log(error);
						});
				}
			},
			displayLabelSetting ({id, text}) {
				return `${text}`;
			},
		},
		async mounted() {
			if (this.id > 0){
				this.reloadEverything();
				let duplicate = new URL(window.location.toString()).searchParams.get("duplicate");
				// if( duplicate == "1" )
					this.tankNoVerified = false;
				// else
				// 	this.tankNoVerified = true;
			}
			this.allTankTypeIdList = await this.loadAllTankType(true);
			this.allTcodeIdList = await this.loadAllTcode(true);
			let _allCustomerIdList = await this.loadAllCustomer(true);
			if(Array.isArray(_allCustomerIdList) && _allCustomerIdList.length > 0){
				this.allCustomerIdList = _allCustomerIdList.map(x => {return { id: x.id, text: x.name }});
			}
			let _allInspectionLocationIdList = await this.loadAllInspectionLocation(true);
			if(Array.isArray(_allInspectionLocationIdList) && _allInspectionLocationIdList.length > 0){
				this.allInspectionLocationIdList = _allInspectionLocationIdList.map(x => {return { id: x.id, text: x.name }});
			}
			let _allCleaningLocationIdList = await this.loadAllCleaningLocation(true);
			if(Array.isArray(_allCleaningLocationIdList) && _allCleaningLocationIdList.length > 0){
				this.allCleaningLocationIdList = _allCleaningLocationIdList.map(x => {return { id: x.id, text: x.name }});
			}
			this.allImoStatusList = [
				{id: "1", title: "Import"},
				{id: "0", title: "Export"}
			];
			this.allSealedList = [
				{id: "1", title: "Sealed"},
				{id: "0", title: "Unsealed"}
			];
			this.arrYesNo = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"}
			];
			this.arrYesNoNA = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allBvboxsuList = [
				{id: "1", title: "Sealed"},
				{id: "0", title: "Unsealed"}
			];
			if (this.imo5conditionForAdd.customer_id) {
				if (Array.isArray(this.allCustomerIdList) && this.allCustomerIdList.length > 0) {
					let _allRelationList = this.allCustomerIdList;
					let relationId = parseInt(this.imo5conditionForAdd.customer_id);
					this.imo5conditionForAdd.customer_id = _allRelationList.find(item => item.id === relationId);
				}
			}
			if (this.imo5conditionForAdd.inspection_location_id) {
				if (Array.isArray(this.allInspectionLocationIdList) && this.allInspectionLocationIdList.length > 0) {
					let _allRelationList = this.allInspectionLocationIdList;
					let relationId = parseInt(this.imo5conditionForAdd.inspection_location_id);
					this.imo5conditionForAdd.inspection_location_id = _allRelationList.find(item => item.id === relationId);
				}
			}
			if (this.imo5conditionForAdd.cleaning_location_id) {
				if (Array.isArray(this.allCleaningLocationIdList) && this.allCleaningLocationIdList.length > 0) {
					let _allRelationList = this.allCleaningLocationIdList;
					let relationId = parseInt(this.imo5conditionForAdd.cleaning_location_id);
					this.imo5conditionForAdd.cleaning_location_id = _allRelationList.find(item => item.id === relationId);
				}
			}
		}
	};
</script>
<style lang=""></style>
